import { render, staticRenderFns } from "./ZoomSalas.vue?vue&type=template&id=7e66bc19&scoped=true&"
import script from "./ZoomSalas.vue?vue&type=script&lang=js&"
export * from "./ZoomSalas.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSalas.vue?vue&type=style&index=0&id=7e66bc19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66bc19",
  null
  
)

export default component.exports